import { HTMLAttributes } from "react"
import { styled, callCSSFn, StylePropsWithCSS, WithCSS } from "../styles"

type ListProps = HTMLAttributes<HTMLUListElement> & WithCSS
export const BasicList = styled.ul<ListProps>((props: StylePropsWithCSS) => ({
  ...callCSSFn(props),
}))

type ItemProps = HTMLAttributes<HTMLLIElement> & WithCSS
export const BasicListItem = styled.li<ItemProps>((props: StylePropsWithCSS) => ({
  ...callCSSFn(props),
}))
